import { render } from "./CartFooter.vue?vue&type=template&id=52315f0c&scoped=true"
import script from "./CartFooter.vue?vue&type=script&lang=js"
export * from "./CartFooter.vue?vue&type=script&lang=js"

import "./CartFooter.vue?vue&type=style&index=0&id=52315f0c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52315f0c"]])

export default __exports__